// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="5.5" y="2.5" width="13" height="20" stroke={props.color} />
			<rect x="7" y="4" width="10" height="15" fill={props.color} />
			<rect x="11" y="20" width="2" height="1" fill={props.color} />
		</svg>
	</>
);

export default Icon;
